export const DETAILS_CONFIG = {
    acceptingResponses: {
        title: 'Accepting responses',
        description: 'Stop accepting responses to view results.',
    },
    generatingResults: {
        title: 'Generating Results...',
        description: `Wrapping up responses...
Cleaning up results...
Generating insights...`,
    },
    surveyClosed: {
        title: 'Survey closed',
        description: 'No longer accepting responses.',
    },
}
